<template>
    <div class="top-nav-right-btns_con">
         <el-dropdown v-if="ishbdx==='1'">
            <el-button type="text" style="margin-right:10px;">
              <i class="el-icon-chat-dot-round"></i> 客服
            </el-button>
            <el-dropdown-menu slot="dropdown" class="xxx">
                <el-dropdown-item style="color:#409EFF;font-weight:800;font-size:13px">系统问题请联系：</el-dropdown-item>
                <el-dropdown-item >手机号：15803215511</el-dropdown-item>
                <el-dropdown-item>固定电话：4007809998</el-dropdown-item>
                <el-dropdown-item style="color:#409EFF;font-weight:800;font-size:13px">项目问题请联系：</el-dropdown-item>
                <el-dropdown-item>手机号：18032103496</el-dropdown-item>
                <el-dropdown-item>固定电话：0311-85818063</el-dropdown-item>
            </el-dropdown-menu>
        </el-dropdown>

        <el-button
            v-for="(item, index) in btnList"
            :key="index"
            type="text"
            :icon="item.icon"
            @click="item.click"
      >
            {{item.text}} 
        </el-button>
    </div>
</template>

<script>
export default {
    data() {
        return{
            ishbdx:''
        }
    },
    computed: {
        btnList() {
            return this.getGetters(`${this.getGetters('system').type}_topNavRightBtns`) || [];
        }
    },
    created() {
        this.ishbdx = getSession('ishbdx')
    },
}
</script>

<style lang="scss" scoped>
.top-nav-right-btns_con{float:right; padding:0; line-height:50px;}
.el-dropdown-menu__item {
    line-height: 24px;
    font-size: 12px;
    cursor: default;
}
.el-dropdown-menu__item:hover {
    background-color: #fff;
    color: #606266;
}
</style>